export default __webpack_public_path__ + "static/media/img-0635-moldova-premium-face.8c73328e.png";